import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { ROUTES } from '@shared/api';

/**
 * Opens a Server-Sent Events connection and, on each telemetry/alarm frame,
 * invalidates the live queries so the console updates in near-real-time instead
 * of waiting for the ≤5s poll (which remains as a fallback if SSE drops).
 */
export function useEventStream(): void {
  const qc = useQueryClient();
  useEffect(() => {
    if (typeof EventSource === 'undefined') return;
    const es = new EventSource(ROUTES.stream);
    const refresh = (): void => {
      for (const g of [['cockpit'], ['telemetry'], ['hang'], ['alarms'], ['notifications'], ['history']]) {
        qc.invalidateQueries({ queryKey: g });
      }
    };
    es.addEventListener('telemetry', refresh);
    es.addEventListener('alarm', refresh);
    es.onerror = () => {
      /* EventSource reconnects automatically; poll fallback covers the gap. */
    };
    return () => es.close();
  }, [qc]);
}
